export const columns = [
  {
    title: '保函编号',
    dataIndex: 'code',
    scopedSlots: { customRender: 'code' },
    width: 180,
    ellipsis: true,
  },
  {
    title: '交易中心唯一编号',
    dataIndex: 'de_toubaono',
    scopedSlots: { customRender: 'de_toubaono' },
    width: 310,
    ellipsis: true,
  },
  {
    title: '项目名称',
    dataIndex: 'project',
    scopedSlots: { customRender: 'project' },
    ellipsis: true,
  },
  {
    title: '开标时间',
    dataIndex: 'kbdate',
    width: 165,
    ellipsis: true,
  },
  {
    title: '担保金额',
    dataIndex: 'money',
    customRender: (text) => {
      return (text || 0) + '元';
    },
    width: 90,
    ellipsis: true,
  },
  {
    title: '担保费',
    dataIndex: 'poundage',
    customRender: (text) => {
      return (text || 0) + '元';
    },
    width: 80,
    ellipsis: true,
  },
  {
    title: '申请人',
    dataIndex: 'bidder',
    scopedSlots: { customRender: 'bidder' },
    width: 220,
    ellipsis: true,
  },
  {
    title: '支付时间',
    dataIndex: 'pay_time',
    customRender: (text) => {
      return text === '0001-01-01 00:00:00' ? '' : text;
    },
    width: 165,
    ellipsis: true,
  },
  {
    title: '出函时间',
    dataIndex: 'sign_time',
    customRender: (text) => {
      return text === '0001-01-01 00:00:00' ? '' : text;
    },
    width: 165,
    ellipsis: true,
  },
];
